exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".wrap img[data-v-0c2d5ef9] {\n  width: 100%;\n}\n", ""]);

